import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { EnrichedCustomer, EnrichedLocation } from '@/models/enriched-prismic-documents.ts';

type ConfigStore = {
    selectedCustomer: EnrichedCustomer | undefined;
    selectedLocation: EnrichedLocation | undefined;
    userCustomers: EnrichedCustomer[];
    setSelection: (customer: EnrichedCustomer, location: EnrichedLocation) => void;
    reset: () => void;
};

const initialState = {
    selectedCustomer: undefined,
    selectedLocation: undefined,
    userCustomers: [],
};

export const useConfigStore = create<ConfigStore>()(
    persist(
        (set) => ({
            ...initialState,
            setSelection: (customer: EnrichedCustomer, location: EnrichedLocation): void =>
                set({ selectedCustomer: customer, selectedLocation: location }),
            reset: (): void => set({ ...initialState }),
        }),
        {
            name: 'config-store',
        }
    )
);
